import { useCallback, useState } from 'react';

import { DeleteDialogCustomField } from 'common/components/deleteDialog/DeleteDialogCustomField';
import { selectPageInfo, setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { deleteLicense } from 'common/services/api/Licenses/Licenses.thunk';
import { dateToFrontEndFormat } from 'common/utils/dateHelpers';
import { handleDeleteDialogError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { DeleteDialog } from '../../common/components/deleteDialog/DeleteDialog';
import { setDialogOpen } from '../../common/components/deleteDialog/deleteDialogSlice';
import { DeleteDialogContentProps } from '../../common/types/TypeDefs';

export function LicensesDeleteDialogContent({
    title,
    itemId,
    editingRow
}: Readonly<DeleteDialogContentProps<{ companyKey: string, startDate: string }>>) {
    const { companyKey, startDate } = editingRow ?? {};
    const { enqueueSnackbar } = useSnackbar();
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const pageInfo = useAppSelector(selectPageInfo);

    const licenseDeleteCallback = useCallback(() => {
        if (itemId) {
            setProcessing(true);
            dispatch(deleteLicense({
                tenantId: pageInfo?.id ?? '',
                licenseId: itemId,
            }))
                .unwrap()
                .then((result) => {
                    dispatch(setRows(result.rows));
                    dispatch(setDialogOpen(false));
                    enqueueSnackbar('License has been deleted.', { variant: 'success' });
                })
                .catch(error => {
                    handleDeleteDialogError('License', enqueueSnackbar, extractStatusCode(error.message));
                })
                .finally(()=> {
                    setProcessing(false);
                });
        }
    }, [itemId]);

    return  (
        <DeleteDialog deleteCallback={licenseDeleteCallback} processing={processing ?? false} title={title}>
            <DeleteDialogCustomField fieldName='Company Key' fieldValue={companyKey}/>
            <DeleteDialogCustomField fieldName='Start Date' fieldValue={dateToFrontEndFormat(startDate)}/>
            <DeleteDialogCustomField fieldName='Tenant Name' fieldValue={pageInfo?.name ?? ''}/>
        </DeleteDialog>
    );
}
